import React, { useEffect, useState } from 'react';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import { Card, CardBody } from '../../../../components/card/card';
import AddAttendanceAdjustment from './AddAttendanceAdjustment';
import UpdateAttendanceAdjustment from './UpdateAttendanceAdjustment';
import { Link } from 'react-router-dom';
import Select from 'react-select';

import { useTranslation } from 'react-i18next';
import ModalComponent from '../../../../components/Modal/ModalComponent';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';
import {
  deletedAttendanceAdjustment,
  getAttendenceAdjustmentByPersonId
} from '../../../../store/HR/Person/AttendanceAdjustmentSlice';
import NtxTable from '../../../../components/DataTable/NtxTable';
import useGetPersons from '../../../../hooks/HR/use-get-persons';
import Loading from '../../../../components/Shared/Loader/Loading';
import { usePermissions } from '@Helper/Permisstions/usePermissions';
import CustomAlert from '../../../../components/Shared/Alert/CustomAlert';
import confirmAction from '../../../../components/Shared/Alert/confirmAction';

const AttendanceAdjustment = () => {
  const { HasPermission } = usePermissions();
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const { dataEmployees, loading: loading2 } = useGetPersons();
  const [search, setSearch] = useState('');
  const [show, setShow] = useState(false);
  const [id, setId] = useState('');

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  useEffect(() => {
    if (selectedEmployee) {
      dispatch(getAttendenceAdjustmentByPersonId({ id: selectedEmployee }));
    } else {
      // dispatch(getAttendenceAdjustmentByPersonId({}));
    }
  }, [selectedEmployee, dispatch]);

  const { AttendenceAdjustmentByPersonId: data, loading, error } = useAppSelector(s => s.AttendanceAdjustment);

  const filteredSearch = data?.slice()?.filter(item => {
    const searchLowerCase = search.toLowerCase();
    const matchesSearch =
      item.personName?.toLowerCase().includes(searchLowerCase) ||
      item.employeeNumber?.toLowerCase().includes(searchLowerCase) ||
      item.personName2?.toLowerCase().includes(searchLowerCase);

    return matchesSearch;
  });

  const columns = [
    { title: t('Name'), key: 'Name' },
    { title: t('EmployeeNumber'), key: 'employeeNumber' },
    { title: t('From'), key: 'startDateTime' },
    { title: t('To'), key: 'endDateTime' },
    { title: t('Type'), key: 'Type' },
    { title: t(''), key: 'action', className: 'text-end' }
  ];

  const tableData = filteredSearch?.map(item => {
    let rowClass;

    return {
      Name: i18n.language === 'en' ? item.personName : item.personName2,
      employeeNumber: item.employeeNumber,
      startDateTime: item.startDateTime,
      endDateTime: item.endDateTime,
      Type: item.attendenceAdjustmentType,
      action: (
        <>
          {HasPermission('ViewDetailsRaqPermissions') && (
            <button
              type='button'
              onClick={() => setId(item.id)}
              className='btn btn-sm btn-outline-theme me-1'
              data-bs-toggle='modal'
              data-bs-target='#modalEdit'
            >
              <i className='fa-solid fa-pen-to-square fa-lg me-2'></i>
              {t('Edit')}
            </button>
          )}
          {HasPermission('EditRaqPermissions') && (
            <>
              <button
                type='button'
                onClick={() => handleDeleteAdjustment(item.id)}
                className='btn btn-sm btn-outline-danger me-1'
              >
                <i className='fas fa-trash-alt fa-lg me-2   '></i>
                {t('Delete')}
              </button>
            </>
          )}
        </>
      ),

      rowClass // استخدم rowClass هنا
    };
  });

  // const handleDeleteAdjustment = async (id: string) => {
  //   let isConfirmation = await confirmAction(t('MsgConfirm'));
  //   if (!isConfirmation) {
  //     return;
  //   }
  //   dispatch(deletedAttendanceAdjustment(id))
  //     .unwrap()
  //     .then((res) => {
  //       debugger;
  //       if (res.succeeded && res.data) {
  //         CustomAlert({ action: 'Add', msg: 'تمت عملية الحذف بنجاح' });
  //         if (selectedEmployee) {
  //           dispatch(getAttendenceAdjustmentByPersonId({ id: selectedEmployee }));
  //         }
  //       } else {
  //         CustomAlert({ action: 'Error' });
  //       }
  //     })
  //     .catch((error) => {
  //       CustomAlert({ action: 'Error' });
  //     });
  // };

  const handleDeleteAdjustment = async (id: string) => {
    try {
      const isConfirmation = await confirmAction(t('MsgConfirm'));
      if (!isConfirmation) return;

      const res = await dispatch(deletedAttendanceAdjustment(id)).unwrap();

      if (res.succeeded && res.data) {
        CustomAlert({ action: 'Add', msg: 'تمت عملية الحذف بنجاح' });
        if (selectedEmployee) {
          await dispatch(getAttendenceAdjustmentByPersonId({ id: selectedEmployee }));
        }
      } else {
        CustomAlert({ action: 'Error', msg: res.message });
      }
    } catch (error) {
      console.error('Error deleting attendance adjustment:', error);
      CustomAlert({ action: 'Error' });
    }
  };

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: t('AttendanceRequests'),
              link: null
            }
          ]}
          PageName='AttendanceRequests'
        />

        {/* {true && ( */}
        {HasPermission('AddRaqPermissions') && (
          <div className='ms-auto'>
            <Link
              onClick={() => setShow(true)}
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAdd'
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('NewAttendanceRequest')}
            </Link>
          </div>
        )}
      </div>

      <Card>
        <CardBody>
          <div className='row  d-flex justify-content-between mb-3'>
            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text fw-bold'>{t('Search')}</span>
                <div className='input-group'>
                  <div className='flex-fill position-relative'>
                    <div className='input-group border-0 '>
                      <div className='input-group-text position-absolute top-0 bottom-0 bg-none border-0 pe-0'>
                        <i className='fa fa-search opacity-5 text-theme'></i>
                      </div>
                      <input
                        type='text'
                        autoComplete='off'
                        className='form-control ps-35px'
                        value={search}
                        onChange={e => {
                          setSearch(e.target.value);
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='col-lg-4'>
              <div className='input-group flex-nowrap'>
                <span className='input-group-text  fw-bold'>{t('EmployeeName')}</span>
                <Select
                  classNamePrefix='react-select'
                  className={`w-100 `}
                  isLoading={loading2}
                  isSearchable={true}
                  isClearable
                  options={dataEmployees}
                  onChange={(option: any) => (option === null ? null : setSelectedEmployee(option.value))}
                  placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                />
              </div>
            </div>
          </div>

          <Loading loading={loading} error={error}>
            <NtxTable
              data={tableData || []}
              columns={columns}
              dataPerPage={10}
              theadClass=''
              tableClass='table text-nowrap table-hover '
              // enableSearch
              // showRecordsSelector
            />
          </Loading>
        </CardBody>
      </Card>

      <ModalComponent title={t('AddNewAttendanceRequest')} id='modalAdd' size='lg'>
        {show && <AddAttendanceAdjustment />}
      </ModalComponent>

      <ModalComponent title={t('EditNewAttendanceRequest')} id='modalEdit' size='lg'>
        {id && <UpdateAttendanceAdjustment id={id} />}
      </ModalComponent>
    </>
  );
};

export default AttendanceAdjustment;
